import Language from "./enums/Language"
import { cancellationTax } from "../blumar-development.config";
let translationWords = [
	{
		language: Language.PORTUGUESE,
		daysPart: (days) => `Até ${days} ${days>1?'dias':'dia'} antes do checkin -`,
		cancelationPolicy: `A Blumar cobrará uma taxa de ${cancellationTax}% do total.`,
		taxPolicyDays: (daysPenalityTax) => ` Depois disso, ${daysPenalityTax} ${daysPenalityTax>1?'noites serão cobradas': 'noite será cobrada'}`,
		taxPolicyPercent: (percentTax) => ` Depois disso, será cobrado ${percentTax}% do valor da reserva`,
		taxPolicyFinalPart: ` + uma taxa de ${cancellationTax}% do total.`,
		refundable: 'Não reembolsável',
	},
	{
		language: Language.ENGLISH,
		daysPart: (days) => `Until ${days} ${days>1?'days':'day'} before checkin -`,
		cancelationPolicy: `Blumar will charge a fee of ${cancellationTax}% of the total.`,
		taxPolicyDays: (daysPenalityTax) => ` After that, ${daysPenalityTax} ${daysPenalityTax>1?'nights will be charged': 'night will be charged'} will be charged`,
		taxPolicyPercent: (percentTax) => ` After that, ${percentTax}% of the reservation amount will be charged`,
		taxPolicyFinalPart: ` + a fee of ${cancellationTax}% of the total.`,
		refundable: 'Non refundable',
	},
	{
		language: Language.SPANISH,
		daysPart: (days) => `Hasta ${days} ${days>1?'días':'día'} antes del checkin -`,
		cancelationPolicy: `Blumar cobrará una tarifa de ${cancellationTax}% del total.`,
		taxPolicyDays: (daysPenalityTax) => ` Después de eso, se cobrará ${daysPenalityTax} ${daysPenalityTax>1?'se cobrarán las noches': 'se cobrará la noche'}`,
		taxPolicyPercent: (percentTax) => ` Después de eso, se cobrará ${percentTax}% del monto de la reserva`,
		taxPolicyFinalPart: ` + una tarifa de ${cancellationTax}% del total.`,
		refundable: 'No reembolsable',
	},
];

export function describeCancelationPolicy(cancellationPolicy, language) {
	let currentLanguage = translationWords.find(tr => tr.language.id === language.id);
	if(cancellationPolicy.nonRefundable) {
		return currentLanguage.refundable;
	}
	let cancelationPolicyDescription = currentLanguage.cancelationPolicy;
	let daysBeforeCheckin = cancellationPolicy.daysBeforeCheckin;
	let daysPenality = cancellationPolicy.dailyPenalty;
	let percentTax = cancellationPolicy.percentagePenalty;
	if(daysBeforeCheckin) {
		cancelationPolicyDescription = `${currentLanguage.daysPart(daysBeforeCheckin)} ${cancelationPolicyDescription}`;
		if(daysPenality)
			cancelationPolicyDescription += currentLanguage.taxPolicyDays(daysPenality) + currentLanguage.taxPolicyFinalPart;
		else if(percentTax)
			cancelationPolicyDescription += currentLanguage.taxPolicyPercent(percentTax) + currentLanguage.taxPolicyFinalPart;
		else
			cancelationPolicyDescription += currentLanguage.taxPolicyPercent(100) + currentLanguage.taxPolicyFinalPart;
	};
	return cancelationPolicyDescription;
}



// WEBPACK FOOTER //
// ./src/cancellation-policy-utils.js